<template>
    <div class="designate">
        <p-header title="指定騎士"/>
        <div class="search">
            <img src="@/assets/img/search-green2.svg">
            <input type="text" v-model="keyword" @input="search" placeholder="輸入騎士編號/電話/推薦碼">
        </div>
        <div class="search-content">
            <driver-item :driver="driver" v-if="driver"/>
        </div>
        <driver-top v-show="!keyword"/>
        <order-top v-show="!keyword"/>
        <div class="footer" v-show="cart.driver">
            <div class="button" @click.stop="confirm">
                指定騎士
            </div>
        </div>
    </div>
</template>

<script>
    import Header from "./components/Header";
    import DriverTop from "./components/designate/DriverTop";
    import OrderTop from "./components/designate/OrderTop";
    import { searchDriver } from '../apis';
    import DriverItem from "./components/designate/DriverItem";
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: "Designate",
        components: {
            'p-header': Header,
            'driver-top': DriverTop,
            'order-top': OrderTop,
            'driver-item': DriverItem,
        },
        data() {
          return {
              keyword: '',
              keywordTime: null,
              driver: null,
          }
        },
        computed: {
           ...mapGetters(['cart']),
        },
        methods: {
            confirm() {
                this.confirmDriver();
                this.$router.back();
            },
            search() {
                if (this.keywordTime) {
                    clearTimeout(this.keywordTime);
                }

                if (this.keyword.length <= 0) {
                    this.driver = null;
                    return;
                }

                this.keywordTime = setTimeout( () => {
                    searchDriver(this.keyword).then(res => {
                        this.driver = res.data;
                    });
                }, 500);
            },
            ...mapActions(['confirmDriver'])
        }
    }
</script>

<style lang="scss" scoped>
    .designate {
        position: relative;
        flex: 1;
        padding-bottom: 60px;

        .search {
            border-radius: 5px;
            background-color: #FFFFFF;
            box-shadow: 0 1px 5px 0 rgba(51,153,51,0.35);
            margin: 5px 15px 0 15px;
            display: flex;

            img {
                width: 20px;
                height: 20px;
                margin: 10px;
            }

            input {
                flex: 1;
                border: none;
            }
        }

        .search-content {
            margin: 15px
        }

        .footer {
            position: fixed;
            bottom: 0;
            padding: 10px 15px;
            width: calc(100% - 30px);
            max-width: 470px;
            background-color: #ffffff;

            .button {
                cursor: pointer;
                user-select: none;
                background-color: #339933;
                padding: 13px;
                border-radius: 35px;
                color: #FFF;
                font-size: 14px;
            }
        }
    }
</style>